// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { SeriesNameInput } from "metabase/visualizations/components/settings/ChartNestedSettingSeries.styled";

export const SliceNameInput = styled(SeriesNameInput)`
  width: 100%;
`;
